// let Swup = require( 'swup' ).default;

import { hide, show, toggle } from 'slidetoggle';
import * as AOS from "aos";


AOS.init({
  // Global settings:
  disable: (
    /bot|crawler|spider|crawling/i.test(navigator.userAgent)
    || window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ),
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 50, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 800, // values from 0 to 3000, with step 50ms
  easing: 'ease-in-out', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});

declare let TimelineMax: any
declare let TweenMax: any
declare let Sine: any



/* Open all PDF links in a new window */
document.querySelectorAll('a').forEach((linkElem: Element, index) => {
	if(linkElem.hasAttribute('href') && linkElem.getAttribute('href').endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});



/* mailencrypting */
setTimeout(function () {
	let mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: HTMLElement, index) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a')
		a.setAttribute('href', `mailto:${maddr}`)
		a.innerHTML = linktext;

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		mail.style.display = 'none';
	});
}, 500);

/* Go to top button */
if(document.querySelector('#to-shine-to-top')) {
	document.querySelector('#to-shine-to-top').addEventListener('click', (e) => {
		e.preventDefault();
	
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	})
}

const navheader = document.querySelector('header');
const navheight = (navheader != null ? navheader.offsetHeight : 0);
window.addEventListener('scroll', function (event) {
	const bc = document.querySelector('.to-shine-page-breadcrumb');
	if(bc != null) {
		(bc as HTMLElement).style.top = `${navheader.offsetHeight - 1}px` ;

		if (window.scrollY > navheight) {
			bc.classList.add('bg-cyan-light' , 'shadow-sm');
		} else {
			bc.classList.remove('bg-cyan-light' , 'shadow-sm');
		}
	}

	const toTop = document.querySelector("#to-shine-to-top");
	if(toTop != null) {
		if (window.scrollY > 300) {
			toTop.classList.add('to-shine-top-visible');
		} else {
			toTop.classList.remove('to-shine-top-visible');
		}
	}
	const contactpersons = document.querySelector(".app-contactpersons");
	if (contactpersons != null){
		if(toTop != null) {
			/* show / hide scroll to top button */
			if (window.scrollY > 200) {
				contactpersons.classList.add('show');
			} else {
				contactpersons.classList.remove('show');
			}
		}
	}
	const flyingcta = document.querySelector(".flying-cta");
	if (flyingcta != null){
		if(toTop != null) {
			/* show / hide scroll to top button */
			if (window.scrollY > 200) {
				flyingcta.classList.add('show');
			} else {
				flyingcta.classList.remove('show');
			}
		}
	}
	const stickyHeader = document.querySelector("#to-shine-page-header");

	if(toTop != null) {
		/* show / hide scroll to top button */
		if (window.scrollY > 100) {
			stickyHeader.classList.add('fixed-header');
		} else {
			stickyHeader.classList.remove('fixed-header');
		}
	}
	
}, false);
// breadcrumb

/* opens sub navs and mobile navs */
document.querySelectorAll('.to-shine-navopener').forEach((openerElem: HTMLElement, index) => {
	openerElem.addEventListener('click', (e) => {
		const targetElem = e.currentTarget as HTMLElement;
		const targetParent = targetElem.parentElement.parentElement;

		if(!targetParent.classList.contains('to-shine-active')) {
			if(targetElem.closest('.has-child').classList.contains('to-shine-active')) {
				document.querySelector('.to-shine-active').classList.remove('to-shine-active')
				hide(document.querySelector('.to-shine-active ul') as HTMLElement, {});
			}
			targetParent.classList.toggle('to-shine-active');
			show(targetParent.querySelector('ul') as HTMLElement, {});
		} else {
			targetParent.classList.toggle('to-shine-active');
			hide(targetParent.querySelector('ul') as HTMLElement, {});
		}
	})
})

// 2ro - not active as long as breadcrumb is not used
// const bc = document.querySelector('.to-shine-page-breadcrumb');
// if(bc != null){
// 	document.querySelector('.to-shine-page-breadcrumb span a:last-child').classList.add('last');
// 	document.querySelector('.to-shine-page-breadcrumb span:last-child').classList.add('last');
// 	if(document.querySelector('.to-shine-page-breadcrumb span .to-shine-page-breadcrumb-link:nth-last-child(3)') != null) {
// 		document.querySelector('.to-shine-page-breadcrumb span .to-shine-page-breadcrumb-link:nth-last-child(3)').classList.add('second-last');
// 	}
// 	bc.classList.toggle('to-shine-page-breadcrumb-shortened', (document.querySelector('.to-shine-page-breadcrumb-link') != null || document.querySelectorAll('.to-shine-page-breadcrumb-link').length > 2))
// 	document.querySelector('.to-shine-page-breadcrumb-trigger').addEventListener('click', () => {
// 		bc.classList.toggle('to-shine-page-breadcrumb-shortened')
// 	})
// }


/* DIALOG */
document.querySelectorAll('a[data-dialog]').forEach((dialogLink: HTMLElement, index) => {
	dialogLink.addEventListener('click', (e) => {
		e.preventDefault();

		const linkElem = e.currentTarget as HTMLElement;
		showDialog(linkElem);
	})
})

var flyoutContentClose = document.querySelector('.app-flyoutcontent-iframe-wrapper .close');
if(flyoutContentClose != null) {
	flyoutContentClose.addEventListener('click', (e) => {
		e.preventDefault();
		hideDialog()
	})
}


var flyoutContentUnderlay = document.querySelector('.app-flyoutcontent-underlay');
if(flyoutContentUnderlay != null) {
	flyoutContentUnderlay.addEventListener('click', (e) => {
		e.preventDefault();
		hideDialog()
	})
}


function showDialog(elem: HTMLElement) {
	const currentPageHref = window.location.href;
	const currentPageTitle = document.title;
	const iframeLink = elem.getAttribute('href');
	document.querySelector('.app-flyoutcontent-iframe-wrapper iframe').setAttribute('src', `${iframeLink}?SkinSrc=[G]Skins/2sic/skeleton&ref=${currentPageHref}&title=${currentPageTitle}`);
	
	document.querySelector('.app-flyoutcontent-iframe-wrapper').classList.add('is-open');
	document.querySelector('.app-flyoutcontent-underlay').classList.add('is-visible');
	document.querySelector('body').classList.add('disable-scroll');
}

function hideDialog() {
	document.querySelector('.app-flyoutcontent-iframe-wrapper').classList.remove('is-open');
	document.querySelector('.app-flyoutcontent-underlay').classList.remove('is-visible');
	document.querySelector('body').classList.remove('disable-scroll');
	document.querySelector('.app-flyoutcontent-iframe-wrapper iframe').setAttribute('src','');

}

